import React from 'react';
import { SdmDialog } from 'components';

function AcceptInvitationDialog({ onClose, i18n }) {
  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 60 }}>
        <img
          style={{ height: 100, width: '100%' }}
          src="/themes/custom/sdm/images/header/logo-black.svg"
        ></img>
        <h2 style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}>
          {i18n.title}
        </h2>
      </div>
    );
  };
  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.agree}
      onAgree={onClose}
      paperStyle={{
        borderRadius: 15,
        width: 410,
        height: 509,
        padding: 0,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionStyle={{ height: 47, width: 192, margin: 0 }}
      actionTextStyle={{ fontSize: 20 }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 24,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
    >
      <div
        style={{
          width: 330,
          textAlign: 'center',
          fontSize: 20,
        }}
      >
        {i18n.body}
      </div>
    </SdmDialog>
  );
}

export default AcceptInvitationDialog;
